import axios from 'axios';

axios.defaults.headers.common['app-key'] = '88ed5442771c4e39a74279f0f227422a';

export default axios;
